import { exfluencyLogoSvg } from "./logo.svg";
import './styles.scss';
export class ExfluencyLoader extends HTMLElement {
    constructor(fullscreen, background, height, width) {
        super();
        this.className = "loader-wrapper";
        if (background)
            this.style.backgroundColor = background;
        if (fullscreen)
            this.classList.add('fullscreen');
        this.innerHTML = exfluencyLogoSvg;
        if (height)
            this.style.height = height;
        if (width)
            this.style.width = width;
    }
}
document.addEventListener("DOMContentLoaded", () => customElements.define("xfl-new-editor-exfluency-loader", ExfluencyLoader));
